import { Reducer } from 'redux';
import { StandardSummaryActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  results: [],
  standardSummaryTypes: [],
  standardSummaryDatabases: []
};

type IStandardSummarySearchStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IStandardSummarySearchStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case StandardSummaryActionTypes.SEARCH: {
      let _state = { ...state };
      _state = { ..._state, results: action.value };
      return _state;
    }
    case StandardSummaryActionTypes.GENERATE: {
      let _state = { ...state };
      _state = { ..._state, results: [...state.results, action.value] };
      return _state;
    }
    case StandardSummaryActionTypes.TYPES: {
      let _state = { ...state };
      _state = { ..._state, standardSummaryTypes: action.value };
      return _state;
    }
    case StandardSummaryActionTypes.DATABASES: {
      let _state = { ...state };
      _state = { ..._state, standardSummaryDatabases: action.value };
      return _state;
    }
    case StandardSummaryActionTypes.REGENERATE: {
      let _state = { ...state };
      _state.results = [
        ..._state.results.map((standardSummary) =>
          standardSummary.id == action.value.id
            ? { ...standardSummary, ...action.value }
            : standardSummary
        ),
      ];
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
